/**
 * solvia-about-bg-switch.js (T#016 / T#020 / T#026)
 *
 * About ページの fixed background layer (about-fixed-bg.liquid) で、
 * `data-target` に指定された section の top が viewport 中央 (vh/2) を
 * 通過したタイミング (= 要素が画面上半分に到達 = 読まれ終わりニュアンス)
 * で `.is-switched` を toggle する。CSS 側の `transition: opacity ...`
 * が layer A → B を双方向 fade する。
 *
 * - prefers-reduced-motion: reduce はそのまま動かす (CSS で transition 無効)
 * - DOM 要素 (.solvia-about-fixed-bg) が無いページでは即 return で無害
 * - 判定は scroll/resize listener で都度 update。IO は補助 (rootMargin default)。
 */

(() => {
  const init = () => {
    const fixedBg = document.querySelector('.solvia-about-fixed-bg[data-target]');
    if (!fixedBg) return;

    const targetId = fixedBg.getAttribute('data-target');
    if (!targetId) return;

    // section id は Shopify 出力で `shopify-section-template--XXX__<key>` 形式のため
    // 部分一致で拾う (key は小文字 kebab-case 想定)。
    const target = document.querySelector(`[id*="${targetId}"]`);
    if (!target) return;

    const update = () => {
      // target の top が viewport 中央以下に達したかで判定。
      // = 要素が画面上半分に到達 (読み終わりタイミング) の状態。
      const rect = target.getBoundingClientRect();
      const isSwitched = rect.top <= window.innerHeight / 2;
      fixedBg.classList.toggle('is-switched', isSwitched);
      // T#030 — 同タイミングで body に is-bg-switched を付与し、
      // header icon (menu/logo/account/cart) を solvia-v2.css の
      // body.is-bg-switched override 経由で 50_gray にフリップする。
      document.body.classList.toggle('is-bg-switched', isSwitched);
    };

    // 初期同期 (ページ途中ロード対応)
    update();

    // IntersectionObserver: target が viewport 中央通過のタイミングで update。
    // rootMargin は default にして「target が viewport に出入りする瞬間」を
    // 交差イベントとして拾う。境界精度は scroll/resize listener が担保。
    const io = new IntersectionObserver(update, {
      root: null,
      threshold: 0,
    });
    io.observe(target);

    // scroll / resize 変動時の主観測 (passive)
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
